import { Link } from 'react-router-dom';

function NotFound() {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-5 text-center">
            <h1 className="text-6xl m-0 text-gray-800">404</h1>
            <h2 className="text-2xl my-2.5 text-gray-600">Page Not Found</h2>
            <p className="text-base my-5 text-gray-500 max-w-sm">
                The page you're looking for doesn't exist or has been moved.
            </p>
            <Link
                to="/"
                className="px-5 py-2.5 bg-blue-600 text-white no-underline rounded mt-5 hover:bg-blue-700 transition-colors"
            >
                Go Home
            </Link>
        </div>
    );
}

export default NotFound; 